import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  const approachItems = [
    {
      title: t('about.approach.discovery.title'),
      description: t('about.approach.discovery.description'),
    },
    {
      title: t('about.approach.design.title'),
      description: t('about.approach.design.description'),
    },
    {
      title: t('about.approach.improvement.title'),
      description: t('about.approach.improvement.description'),
    },
  ];

  return (
    <div className="min-h-screen bg-laynext-cream pt-20 sm:pt-24">
      {/* Hero Section */}
      <section className="py-8 sm:py-12 md:py-16 bg-laynext-white border-b border-gray-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-gray-900 mb-3 sm:mb-4"
            >
              {t('about.heroTitleStart')}
              <span className="text-laynext-orange"> {t('about.heroTitleHighlight')} </span>
              {t('about.heroTitleEnd')}
            </motion.h1>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-xl">
              {t('about.heroDescription')}
            </p>
          </div>
          <div className="flex-1 flex justify-center lg:justify-end">
            <div className="relative">
              <div className="h-28 w-28 sm:h-32 sm:w-32 rounded-3xl bg-laynext-orange/10 flex items-center justify-center">
                <img
                  src="/assets/Laynext_Turuncu.png"
                  alt="Laynext Logo"
                  className="h-14 w-14 sm:h-16 sm:w-16 object-contain"
                />
              </div>
             
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-8 sm:py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-10">
          <div>
            <h2 className="text-sm font-semibold tracking-wide text-gray-500 uppercase mb-3">
              {t('about.missionLabel')}
            </h2>
   
            <p className="text-base text-gray-600 leading-relaxed">
              {t('about.missionDescription')}
            </p>
          </div>
          <div>
            <h2 className="text-sm font-semibold tracking-wide text-gray-500 uppercase mb-3">
              {t('about.visionLabel')}
            </h2>
            <p className="text-base text-gray-600 leading-relaxed">
              {t('about.visionDescription')}
            </p>
       
          </div>

        </div>
      </section>

      {/* Approach */}
      <section className="py-8 sm:py-12 md:py-16 bg-laynext-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-900 mb-6 sm:mb-8">
            {t('about.approachTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {approachItems.map((item) => (
              <div
                key={item.title}
                className="bg-white border border-gray-100 rounded-xl p-6 shadow-sm"
              >
                <h3 className="text-base font-medium text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
